import React from 'react';
import styles from './contact.module.css';

const Contact = () => (
    <div className={styles.contactContainer}>
      <div className={styles.contactSection}>
        <div className={styles.contactHeader}> Contact</div>
        <div className={styles.emailText}>let us chat, discuss at doddapaneni.ajay@gmail.com</div>
        </div>
        </div>
  );

export default Contact;